// extracted by mini-css-extract-plugin
export default {"game_banner":"GameBanner_game_banner__VJ9wf","game_banner_description":"GameBanner_game_banner_description__25YU7","game_banner_text":"GameBanner_game_banner_text__15qrW"};